import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FeatureSubscriptionProductCode } from 'queries';

import { getPlanOptionIndex } from 'utils/feature-subscription';

import { CardButton } from './card-button';
import { CardButtonGroup } from './card-button-group';

type Props = {
  currentPlan?: FeatureSubscriptionProductCode | null;
  isUpdating: boolean;
  handlePlanOnClick: Function;
  order: number;
  selectedPlan: FeatureSubscriptionProductCode | null;
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginLeft: '30px',
    marginBottom: '75px',
  },
  gridItem: {
    padding: '0px',
    margin: '10px',
  },
  listNumber: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ddd',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    marginRight: '15px',
  },
  orderedListContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
  },
  pageContainer: {
    margin: '15px',
  },
}));

export const PlanSelection = ({
  currentPlan,
  isUpdating,
  handlePlanOnClick,
  order,
  selectedPlan,
}: Props) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.orderedListContainer}>
        <Typography className={classes.listNumber}>{order}</Typography>
        <Typography variant="h6">
          {isUpdating ? 'Upgrade your Plan' : 'Confirm Your Plan'}
        </Typography>
      </div>
      <Grid container direction="row" spacing={2} className={classes.gridContainer}>
        <CardButtonGroup defaultSelected={getPlanOptionIndex(selectedPlan)}>
          {
            // The Lite, Solo, and Trial plan will not appear when upgrading because it is the lowest tier plan
          }
          {!isUpdating && (
            <>
              {/* <Grid item className={classes.gridItem}>
                <CardButton
                  id={1}
                  title="Trial"
                  subtitle="Supports 1 seat"
                  showChip={false}
                  handleOnClick={handlePlanOnClick}
                  productCode={FeatureSubscriptionProductCode.TrialPlan}
                />
              </Grid> */}
              <Grid item className={classes.gridItem}>
                <CardButton
                  id={1}
                  title="Solo"
                  subtitle="Supports 2 seats"
                  showChip={false}
                  handleOnClick={handlePlanOnClick}
                  productCode={FeatureSubscriptionProductCode.SoloPlan}
                />
              </Grid>
            </>
          )}
          {(!isUpdating || (isUpdating && 3 > getPlanOptionIndex(currentPlan!))) && (
            <>
              <Grid item className={classes.gridItem}>
                <CardButton
                  id={2}
                  title="Small Firm"
                  subtitle="Supports 4 seats"
                  showChip={false}
                  handleOnClick={handlePlanOnClick}
                  productCode={FeatureSubscriptionProductCode.SmallFirmPlan}
                />
              </Grid>
            </>
          )}
          {(!isUpdating || (isUpdating && 4 > getPlanOptionIndex(currentPlan!))) && (
            <>
              <Grid item className={classes.gridItem}>
                <CardButton
                  id={3}
                  title="Mid-Large Firm"
                  subtitle="Supports 8 seats"
                  showChip={false}
                  handleOnClick={handlePlanOnClick}
                  productCode={FeatureSubscriptionProductCode.MidLargeFirmPlan}
                />
              </Grid>
            </>
          )}
        </CardButtonGroup>
      </Grid>
    </>
  );
};
